var _rect, _g, _g2, _g3, _rect2, _rect3, _g4, _rect4, _path, _rect5, _path2, _rect6, _path3, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicAdvantageTeaser02Small(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 326 308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 326,
    height: 308,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 308,
    height: 326,
    x: 326,
    fill: "#fff",
    rx: 28,
    transform: "rotate(90 326 0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 162.295,
    cy: -246.295,
    r: 414.705,
    fill: "url(#b)",
    transform: "rotate(90 162.295 -246.295)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234.836,
    height: 174.432,
    x: 45.582,
    y: 49.862,
    fill: "#fff",
    rx: 6.004
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.4,
    d: "M48.047 61.95a9.006 9.006 0 0 1 9.006-9.006h211.893a9.006 9.006 0 0 1 9.006 9.006v148.407a9.006 9.006 0 0 1-9.006 9.006H57.053a9.006 9.006 0 0 1-9.006-9.006V61.95Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 114.644,
    height: 16.642,
    x: 105.986,
    y: 131.839,
    fill: "#fff",
    rx: 8.321
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 28.352,
    height: 28.352,
    x: 149.133,
    y: 94.24,
    fill: "#fff",
    rx: 14.176
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.611,
    height: 136.833,
    x: 32.023,
    y: 40,
    fill: "#fff",
    rx: 6.004
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 38.214,
    height: 40.063,
    x: 35.723,
    y: 44.931,
    fill: "#EEE",
    rx: 6.876
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A0F33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.252,
    d: "M54.83 54.998v2.055m0 16.436v2.054m-8.22-10.272h-2.054m4.431-5.841-1.452-1.453M60.67 59.43l1.453-1.453M48.988 71.116l-1.452 1.453m13.134-1.453 1.453 1.453m2.979-7.298h-2.055m-3.082 0a5.136 5.136 0 1 1-10.272 0 5.136 5.136 0 0 1 10.272 0Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 38.214,
    height: 39.447,
    x: 35.723,
    y: 88.693,
    fill: "#EEE",
    rx: 6.876
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A0F33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.252,
    d: "M54.83 104.634v4.707h3.555m5.69-.924a9.245 9.245 0 0 1-9.246 9.245 9.246 9.246 0 1 1 9.245-9.245Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 38.214,
    height: 40.063,
    x: 35.723,
    y: 131.839,
    fill: "#EEE",
    rx: 6.876
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A0F33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.252,
    d: "M58.729 160.885h-9.284c-.606 0-.91 0-1.05-.12a.501.501 0 0 1-.174-.42c.014-.185.229-.399.658-.828l8.516-8.516c.397-.397.595-.595.824-.67.2-.065.418-.065.619 0 .228.075.427.273.823.67l3.875 3.874v1.202m-4.807 4.808c1.682 0 2.524 0 3.166-.328a3.005 3.005 0 0 0 1.314-1.313c.327-.643.327-1.484.327-3.167m-4.807 4.808h-8.414c-1.682 0-2.524 0-3.167-.328a3.006 3.006 0 0 1-1.313-1.313c-.327-.643-.327-1.484-.327-3.167v-8.413c0-1.683 0-2.524.327-3.167a3.006 3.006 0 0 1 1.313-1.313c.643-.328 1.485-.328 3.167-.328h8.414c1.682 0 2.524 0 3.166.328a3.005 3.005 0 0 1 1.314 1.313c.327.643.327 1.484.327 3.167v8.413m-10.516-7.712a2.003 2.003 0 1 1-4.007 0 2.003 2.003 0 0 1 4.007 0Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294.008,
    height: 11.711,
    x: 15.996,
    y: 218.747,
    fill: "#fff",
    rx: 5.856
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 264.857,
    height: 204.453,
    x: 30.572,
    y: 37.854,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.002
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.505
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 235.91,
    height: 172.424,
    x: 45.045,
    y: 49.942,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.501
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 75.632,
    height: 166.854,
    x: 17.013,
    y: 27.992,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.002
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.505
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 324.029,
    height: 41.732,
    x: 0.986,
    y: 206.738,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.002
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.505
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 484.059,
    x2: 428.294,
    y1: -567.847,
    y2: -33.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2B4190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 163,
    x2: 163,
    y1: 52.944,
    y2: 219.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicAdvantageTeaser02Small);
export default __webpack_public_path__ + "static/media/sonic-advantage-teaser-02-small.675b2c0a662656cc8a84c8aa4ad81a65.svg";
export { ForwardRef as ReactComponent };